import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { Quotation } from "../../../generated/graphql";
import moment from "moment";

const QuotationHeader: React.FC<{ quotation: Quotation }> = ({ quotation }) => {
  const lines = [
    {
      label: "Date itinerary",
      value: moment(quotation?.itineraryDate).format("DD MMMM Y"),
    },
    {
      label: "Date Confirmend",
      value: quotation?.confirmedAt
        ? moment(quotation?.confirmedAt).format("DD MMMM Y")
        : "-",
    },
    {
      label: "Booking Code",
      value: quotation?.bookingCode,
    },
    {
      label: "Status",
      value: quotation?.status,
    },
  ];

  return (
    <>
      <Image style={styles.banner} src="/images/quotation-header.png" />
      <View style={styles.itineraryContainer}>
        <Text style={styles.itineraryText}>
          Itinerary: {quotation?.itinerary}
        </Text>
        <Text style={styles.itineraryText}>To: {quotation?.to}</Text>
      </View>
      <View style={{ fontFamily: "Poppins" }}>
        {lines.map((elm, index) => (
          <View
            key={index}
            style={[
              styles.lineItem,
              {
                backgroundColor: (index + 1) % 2 === 0 ? "#fff" : "#f2f2f3",
              },
            ]}
          >
            <Text style={[styles.lineItemText, { width: 100 }]}>
              {elm.label}
            </Text>
            <Text style={styles.lineItemText}>:</Text>
            <Text style={styles.lineItemText}>{elm.value}</Text>
          </View>
        ))}
      </View>
      <View style={styles.line} />
    </>
  );
};

// Create styles
const styles = StyleSheet.create({
  banner: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 84,
  },
  itineraryContainer: {
    backgroundColor: "#192855",
    paddingTop: 4,
    paddingBottom: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 64,
  },
  itineraryText: {
    color: "#fff",
    fontSize: 10,
    textTransform: "uppercase",
    fontFamily: "Poppins",
    fontWeight: 600,
  },
  lineItem: {
    display: "flex",
    flexDirection: "row",
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 4,
    paddingRight: 4,
    gap: 10,
  },
  lineItemText: {
    fontSize: 8,
  },
  line: {
    height: 1,
    backgroundColor: "#192855",
    marginTop: 4,
    marginBottom: 4,
  },
});

export default QuotationHeader;
